export const environment = {
  name: 'prod',
  production: true,
  endpoint: 'https://localhost:7239/',
  timeStamp: '27/10/2025 03:03:36 PM CET',
  commitSha: '0e106a2',
  googleAnalyticsId: 'UA-000000000-0'
};


